// extracted by mini-css-extract-plugin
export default {"container":"DetailsSection_container__zbvtF","outerTabs":"DetailsSection_outerTabs__gSo0j","tabsList":"DetailsSection_tabsList__UEGUA","tab":"DetailsSection_tab__6CTyV"};